import React from "react";
import { ReactComponent as RemoveIcon } from '../../../components/Common/BootstrapIcons/trash.svg';

interface Props<T> {
    values: string[];
    getItemValue: (item: T) => string;
    buildItem: (context: T) => JSX.Element;
    onRemoveClick: (item: T, value: string) => void;
    isRemoveDisabled: (value: string) => boolean;
    showDefaultValues?: boolean;
    items: T[];

}
class DeletableItem<T> extends React.Component<Props<T>, any> {

    constructor(props: Props<T>) {
        super(props);

        this.getListItem = this.getListItem.bind(this);
    }


    getListItem(item: T, i: number): JSX.Element {
        let value = this.props.getItemValue(item);

        return (
            <li key={i} className="row no-gutters">
                <div className="col-auto display-flex">
                    <button className="transparent-button" type="button" onClick={() => this.props.onRemoveClick(item, value)} disabled={this.props.isRemoveDisabled(value)}>
                        <RemoveIcon />
                    </button>
                </div>
                <div className="col">{this.props.buildItem(item)}</div>
            </li>
        );
    }


    render(): JSX.Element {

        return (
            <ul>
                {this.props.showDefaultValues ?
                    this.props.values.map((item: string, index: number) => {
                        return <li key={index} className="row no-gutters display-flex align-items-center">{item}</li>
                    })
                    : this.props.items.filter(x => this.props.values.includes(this.props.getItemValue(x))).map(this.getListItem)
                }
            </ul>

        );
    }
}

export default DeletableItem;